import { GlobalTabsKeysEnum } from './models/custom-app-links';

export const permissionForTab: { [key: string]: string } = {
  [GlobalTabsKeysEnum.marketData]: 'market_data',
  [GlobalTabsKeysEnum.OTCTrader]: 'market_data',
  [GlobalTabsKeysEnum.pricing]: 'market_data',
  [GlobalTabsKeysEnum.marketProbabilities]: 'market_data',
  [GlobalTabsKeysEnum.carryBasis]: 'market_data',
  [GlobalTabsKeysEnum.optionsFlow]: 'market_data',
  [GlobalTabsKeysEnum.portfolioManagement]: 'risk',
  [GlobalTabsKeysEnum.portfolioPerformance]: 'risk',
  [GlobalTabsKeysEnum.backtesting]: 'market_data',
  [GlobalTabsKeysEnum.Admin]: 'admin',
};

export const requiredPermissionForTabKey = (key?: string) => {
  if (!key) return undefined;
  return permissionForTab[key];
};

export const hasPermissionFor = (permissions: string[] = [], requiredOrKey?: string) => {
  if (!requiredOrKey || !Array.isArray(permissions)) return false;
  const required = permissionForTab[requiredOrKey] ?? requiredOrKey;
  return permissions.includes(required);
};
